import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const TestIds = {
  ERROR_STATE: 'generic-error-state'
};
const RefreshLink = ({
  children
}) => /*#__PURE__*/_jsx(Link, {
  onClick: () => window.location.reload(),
  children: children
});
export const GenericErrorState = ({
  inline = false
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingBlockStart: inline ? '1000' : '1700',
    paddingBlockEnd: inline ? '1000' : '1700',
    "data-test-id": TestIds.ERROR_STATE,
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      type: "error",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "common.pageError.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "common.pageError.description_jsx",
        elements: {
          Link: RefreshLink
        }
      })
    })
  });
};